import React, { Component } from 'react';
import { Link } from 'react-router';


class AlarmComponent extends Component {
  handleDeleteAlarm(e) {
    e.preventDefault();

    this.props.deleteAlarm(this.props.index);
  }

  onChange(field, e) {
    this.props.changeAlarm(this.props.index, field, e)
  };

  render() {
    return(
      <div className="panel panel-default">
      
        <div className="panel panel-heading">
          Alarm #{this.props.index + 1}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          [&nbsp;<Link><a href="" onClick={this.handleDeleteAlarm.bind(this)}>Delete</a></Link>&nbsp;]
        </div>
        
        <div className="panel-body">  

          <div className="form-group">
            <label className="control-label" htmlFor="msg">Message</label>
            <input className="form-control" id="msg" type="text" required value={this.props.msg || ''} onChange={this.onChange.bind(this, 'msg')} />
          </div>

          <div className="form-group">
            <label className="control-label" htmlFor="formula">Condition&nbsp;(like: x1&gt;100, &nbsp;a2-a1&lt;0. &nbsp;Basic reading is a1..., extended reading is x1...)</label>
            <input className="form-control" id="formula" type="text" required value={this.props.formula || ''} onChange={this.onChange.bind(this, 'formula')} />
          </div>

        </div>

      </div>
    )
  }
}

class SubMeterForm extends Component {
  constructor() {
    super();

    this.state = {
      activeTab: "node",
      snDisabled: false,      
      node: {
        modbusAddress: 1,
        alarmConfig: {
          flags: 0, 
          alarmItems: [],
        },
      },
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.changeTab = this.changeTab.bind(this);

    this.handleAddAlarm = this.handleAddAlarm.bind(this);
    this.changeAlarm = this.changeAlarm.bind(this);
    this.deleteAlarm = this.deleteAlarm.bind(this);
    this.onAlarmChange = this.onAlarmChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      node: nextProps.node,
      snDisabled: typeof nextProps.node.sn !== "undefined",
    });
  }

  handleSubmit(e) {
    e.preventDefault();
    let node = this.state.node;

    if ( ! node.alarmConfig ) {
      node.alarmConfig = {
        flags: 0, 
        alarmItems: [],
      }
    }
    if ( ! node.alarmConfig.alarmItems ) {
      node.alarmConfig.alarmItems = [];
    }

    this.props.onSubmit(this.state.node);
  }

  changeTab(e) {
    e.preventDefault();
    this.setState({
      activeTab: e.target.getAttribute('aria-controls'),
    });
  }

  onChange(field, e) {
    let node = this.state.node;
    if (e.target.type === "checkbox") {
      node[field] = e.target.checked; 
    } else if (e.target.type === "number") {
      node[field] = parseInt(e.target.value, 10); 
    } else {
      node[field] = e.target.value;
    }
    this.setState({
      node: node,
    });
  }

  onAlarmChange(field, e) {
    let node = this.state.node;

    if (field === "userApp") {
      if (e.target.checked) {
        node.alarmConfig.flags &= ~1;
      } else {
        node.alarmConfig.flags |= 1;
      }
    } else {
      if (e.target.type === "number") {
        node.alarmConfig[field] = parseInt(e.target.value, 10); 
      } else if (e.target.type === "checkbox") {
        node.alarmConfig[field] = e.target.checked;
      } else {
        node.alarmConfig[field] = e.target.value;
      }
    }

    //node = this.updateNodeSettings(this.state.application, node);
    this.setState({node: node});
  };


  handleAddAlarm(e) {
    let node = this.state.node;
    
    e.preventDefault();
    if ( ! node.alarmConfig ) {
      node.alarmConfig = {flags: 0, alarmItems: []};
    }
    if ( ! node.alarmConfig.alarmItems ) {
      node.alarmConfig.alarmItems = [];
    }
    node.alarmConfig.alarmItems.push({
      msg: '',
      formula: '',
    });
    
    this.setState({node : node});
  }

  changeAlarm(index, field, e) {
    let node = this.state.node;
    if (e.target.type === "number") {
      node.alarmConfig.alarmItems[index][field] = parseInt(e.target.value, 10);
    } else if (e.target.type === "checkbox") {
      node.alarmConfig.alarmItems[index][field] = e.target.checked;
    } else {
      node.alarmConfig.alarmItems[index][field] = e.target.value;
    }
    this.setState({node : node});
  }

  deleteAlarm(index) {
    let node = this.state.node;
    node.alarmConfig.alarmItems.splice(index, 1);
    this.setState({node : node});  
  }

  render() {
    let AlarmList = '';
    let node = this.state.node;

    if (!node.alarmConfig || typeof node.alarmConfig.flags === 'undefined') {
      node.alarmConfig = {
        flags: 0,
        alarmItems: []
      }
      this.setState({node : node}); 
    }
    if ( ! node.alarmConfig.alarmItems ) {
      node.alarmConfig.alarmItems = [];
      this.setState({node : node}); 
    }

    AlarmList = node.alarmConfig.alarmItems.map((item, i) => 
      <AlarmComponent index={i} msg={item.msg} formula={item.formula} 
        deleteAlarm={this.deleteAlarm} changeAlarm={this.changeAlarm}/>);

    return(
      <div>

        <ul className="nav nav-tabs">
          <li role="presentation" className={(this.state.activeTab === "node" ? 'active' : '')}><a onClick={this.changeTab} href="#node" aria-controls="node">Major parameters</a></li>
          <li role="presentation" className={(this.state.activeTab === "alarm-settings" ? 'active' : '')}><a onClick={this.changeTab} href="#alarm-settings" aria-controls="alarm-settings">Alarm settings</a></li>
        </ul>


        <form onSubmit={this.handleSubmit}>

          <div className={(this.state.activeTab === "node" ? '' : 'hidden')}>
            <div className="form-group">
              <label className="control-label" htmlFor="sn">Serial number</label>
              <input className="form-control" id="sn" type="text" placeholder="e.g. 12345678" required disabled={this.state.snDisabled} value={this.state.node.sn || ''} onChange={this.onChange.bind(this, 'sn')}  pattern="^[^\\\/?#*<>]+$"/>
              <p className="help-block">
                A serial number is the unique identity of a sub meter and must be globally unique. 
              </p>
            </div>

            <div className="form-group">
              <label className="control-label" htmlFor="address">Address</label>
              <input className="form-control" id="address" type="text" placeholder="xx stree, yy city" value={this.state.node.address || ''} onChange={this.onChange.bind(this, 'address')} />
            </div>

            <div className="form-group">
              <label className="control-label" htmlFor="devEUI">Bridge device EUI</label>
              <input className="form-control" id="devEUI" type="text" placeholder="0000000000000000" pattern="[A-Fa-f0-9]{16}" required value={this.state.node.devEui || ''} onChange={this.onChange.bind(this, 'devEui')} /> 
              <p className="help-block">
                The rs485 bridge's device EUI. 
              </p>
            </div>

            <div className="form-group">
              <label className="control-label" htmlFor="modbusAddress">Modbus address</label>
              <input className="form-control" id="modbusAddress" type="number" placeholder="1-247" min="1" max="247" required value={this.state.node.modbusAddress || ''} onChange={this.onChange.bind(this, 'modbusAddress')} /> 
              <p className="help-block">
                Modbus address of this sub meter. The range between 1 to 247. 
              </p>
            </div>
          </div>

          <div className={(this.state.activeTab === "alarm-settings" ? '' : 'hidden')}>
            <div className="form-group">
              <label className="control-label">Use application alarm settings</label>
              <div className="checkbox">
                <label>
                  <input type="checkbox" name="userApp" id="userApp" checked={(this.state.node.alarmConfig.flags&1)===0} onChange={this.onAlarmChange.bind(this, 'userApp')} /> Use application alarm settings
                </label>
              </div>
              <p className="help-block">
                When checked, it means that this submeter's alarm settings is same as application's alarm settings. <br/>
              </p>
            </div>

            {AlarmList}
            <br />
          </div>

          <hr />

          <div className="btn-group pull-right" role="group" aria-label="...">
            &nbsp;<Link className={(this.state.activeTab === "alarm-settings" ? '' : 'hidden')}><button type="button" onClick={this.handleAddAlarm.bind(this)} className="btn btn-default">Add alarm</button></Link>
            &nbsp;<button type="submit" className={"btn btn-primary pull-right " + (this.state.disabled ? 'hidden' : '')}>Submit</button>
          </div>

        </form>

      </div>
    );
  }
}

export default SubMeterForm;



// WEBPACK FOOTER //
// ./src/components/SubMeterForm.js